import React, { useEffect, useState } from 'react'
import { createMuiTheme, makeStyles, MuiThemeProvider, Snackbar, Switch, TableCell, TextField, Tooltip, Typography, withStyles } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import api from '../api';
import editIcon from '../../assets/1@3x.png';
import { Autocomplete } from '@material-ui/lab';
import format from 'date-fns/format';
import Pagination from '@material-ui/lab/Pagination';
import CloseImage from '../../assets/ic_close.png';
import { useHistory } from 'react-router-dom';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            marginTop: theme.spacing(2),
        },
    },
}));

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTableDraft());
// const options = ct.customOptionsNoPaging()

const style = {
    position: "sticky",
    zIndex: 110
};

export default function DraftScheduleDokter(props) {
    const classes = useStyles();
    const history = useHistory()
    const [dataTable, setDataTable] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [dataCount, setDataCount] = useState(300)
    const [visibleFilter, setVisibleFilter] = useState(false)
    const [loading, setLoading] = React.useState(false)

    const [listDokter, setLitDokter] = useState([])
    const [pickDokter, setPickDokter] = useState([])

    const [listHari, setListHari] = useState([
        'Senin',
        'Selasa',
        'Rabu',
        'Kamis',
        `Jum'at`,
        'Sabtu',
        'Minggu',
    ])
    const [listAntrian, setListAntrian] = useState([
        'FIFO',
        'TIMESLOT',
        'TIMEBLOK'
    ])
    const [listPembayaran, setListPembayaran] = useState([
        'UMUM',
        'BPJS/UMUM',
        'BPJS'
    ])
    const [listRoom, setListRoom] = useState([])
    const [listDataRoom, setListDataRoom] = useState([])
    const [create, setCreate] = useState(false);
    const [read, setRead] = useState(false);
    const [update, setUpdate] = useState(false);
    const [deleted, setDeleted] = useState(false);

    useEffect(() => {
        getCount()
        getListDokter()
        getListRoom()
        getData(page, limit)
        getPermission(props)
    }, [])

    const getPermission = (e) => {
        api.create().getPermission(e.menuid).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setCreate(data.create)
                    setUpdate(data.update)
                    setRead(data.read)
                    setDeleted(data.delete)
                }
            }
        })
    }

    const getCount = (a) => {
        let dok = a ? `filter={"doctor_id":[${a}]}` : ''
        api.create().getLastScheduleDokter(dok).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let dataCount = Number(response.data.data.length) / 10
                    setDataCount(Math.ceil(dataCount))
                }
            }
        })
    }

    const getListDokter = () => {
        api.create().getListDokter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.sort((a, b) => Number(a.name) - Number(b.name)).map((item) => {
                        if (item.deleted_at === null) {
                            data.push(item)
                        }
                    })
                    setLitDokter(data)
                }
            }
        })
    }

    const getListRoom = () => {
        api.create().getRoom().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.sort((a, b) => Number(a.name) - Number(b.name)).map((item) => {
                        if (item.deleted_at === null) {
                            data.push(item.name)
                        }
                    })
                    setListDataRoom(response.data.data)
                    setListRoom(data)
                }
            }
        })
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleFilter = () => {
        getData(1, 10)
    }

    const handleSubmit = () => {
        console.log(dataTable);
        let payload = {
            "doctor_detail_id": 39,
            "effective_date": "2021-11-23",
            "schedule": [
                {
                    "day_id": 1,
                    "session": [
                        {
                            "service_type": 3,
                            "time_type": 3,
                            "time": 0,
                            "quota": "20",
                            "quota_bpjs": null,
                            "time_start": "09:00",
                            "time_end": "18:00",
                            "room_id": 68,
                            "remarks": "",
                            "internal_notes": ""
                        }
                    ]
                },
            ]
        }
    }

    const handleEdit = (tableMeta) => {
        let idx = []
        dataTable.map((item, index) => {
            if (item[0] === tableMeta.rowData[0]) {
                idx.push(index)
            }
        })
        console.log(idx);
        if (idx.length > 0) {
            idx.map((item) => {
                if (dataTable[item][20] === 0) {
                    dataTable[item][20] = 1
                    dataTable[item][21] = 1
                } else {
                    dataTable[item][20] = 0
                }
            })
            forceUpdate()
        }
    }

    const handleCancel = (tableMeta) => {
        let idx = []
        dataTable.map((item, index) => {
            if (item[0] === tableMeta.rowData[0]) {
                idx.push(index)
            }
        })
        console.log(idx);
        if (idx.length > 0) {
            idx.map((item) => {
                if (dataTable[item][20] === 1) {
                    dataTable[item][20] = 0
                }
                if (dataTable[item][21] === 1) {
                    dataTable[item][21] = 0
                }
            })
            forceUpdate()
        }
    }

    const getData = (page, limit, status) => {
        let filter = ``
        let dokter = []
        if (pickDokter.length > 0 && status !== "reset") {
            console.log(pickDokter);
            pickDokter.map((item) => {
                dokter.push(item.id)
            })
            filter = `&filter={"doctor_id":[${dokter}]}`
        }
        api.create().getLastScheduleDokter(`page=${page}&per_page=${limit}${filter}`).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.sort((a, b) => a.doctor_name.localeCompare(b.doctor_name)).map((item) => {
                        if (item.schedule.days.length > 0) {
                            item.schedule.days.map((i, idx) => {
                                data.push([
                                    item.id,
                                    item.polyclinic_id,
                                    item.doctor_id,
                                    item.polyclinic_name,
                                    item.doctor_name,
                                    item.schedule.effective_date,
                                    i.day,
                                    i.time_start,
                                    i.time_end,
                                    i.time_type_desc,
                                    i.time,
                                    i.quota,
                                    i.service_type_desc,
                                    i.quota_bpjs,
                                    i.room_name,
                                    i.remarks,
                                    "",
                                    "",
                                    "",
                                    idx === 0 ? 1 : 0, //parent
                                    0, //editable
                                    0, //konfirmasi
                                ])
                            })
                        }
                    })
                    setDataTable(data)
                    if (status === "reset") {
                        getCount()
                    } else if (pickDokter.length === 0) {
                        getCount()
                    } else {
                        getCount(dokter)
                    }
                }
            }
        })
    }

    const handleSave = () => {
        console.log(dataTable);
        let data = []
        dataTable.map((item) => {
            if (item[21] === 1) {
                data.push(item)
            }
        })

        let dataFix = []
        if (data.length > 0) {
            data.map((item) => {
                let idx = dataFix.findIndex((val) => val.doctor_detail_id === item[2])
                let idxRoom = listDataRoom.findIndex((val) => val.name === item[14])
                let timeStart = isNaN(new Date(item[7]).getTime()) ? new Date(`2014-08-18T${item[7]}`) : item[7]
                let timeEnd = isNaN(new Date(item[8]).getTime()) ? new Date(`2014-08-18T${item[8]}`) : item[8]
                if (idx > -1) {
                    dataFix[idx].schedule.push({
                        "day_id": item[6] === "Senin" ? 1 : item[6] === "Selasa" ? 2 : item[6] === "Rabu" ? 3 : item[6] === "Kamis" ? 4 : item[6] === "Jum'at" ? 5 : item[6] === "Sabut" ? 6 : 0,
                        "session": [
                            {
                                "service_type": item[12] === "UMUM" ? 1 : item[12] === "BPJS/UMUM" ? 2 : 3,
                                "time_type": item[9] === "FIFO" ? 1 : item[9] === "TIMESLOT" ? 2 : 3,
                                "time": item[10],
                                "quota": item[11],
                                "quota_bpjs": item[13] === 0 ? null : item[13],
                                "time_start": format(new Date(timeStart), 'HH:mm'),
                                "time_end": format(new Date(timeEnd), 'HH:mm'),
                                "room_id": listDataRoom[idxRoom].id,
                                "remarks": item[15],
                                "internal_notes": item[15]
                            }
                        ]
                    })
                } else {
                    dataFix.push({
                        doctor_detail_id: item[2],
                        effective_date: format(new Date(item[5]), 'yyyy-MM-dd'),
                        "schedule": [
                            {
                                "day_id": item[6] === "Senin" ? 1 : item[6] === "Selasa" ? 2 : item[6] === "Rabu" ? 3 : item[6] === "Kamis" ? 4 : item[6] === "Jum'at" ? 5 : item[6] === "Sabut" ? 6 : 0,
                                "session": [
                                    {
                                        "service_type": item[12] === "UMUM" ? 1 : item[12] === "BPJS/UMUM" ? 2 : 3,
                                        "time_type": item[9] === "FIFO" ? 1 : item[9] === "TIMESLOT" ? 2 : 3,
                                        "time": item[10],
                                        "quota": item[11],
                                        "quota_bpjs": item[13] === 0 ? null : item[13],
                                        "time_start": format(new Date(timeStart), 'HH:mm'),
                                        "time_end": format(new Date(timeEnd), 'HH:mm'),
                                        "room_id": listDataRoom[idxRoom].id,
                                        "remarks": item[15],
                                        "internal_notes": item[15]
                                    }
                                ]
                            },
                        ]
                    })
                }
            })
        }
        console.log(dataFix);
        api.create().createDraftScheduleDokter(dataFix).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    getData()
                }
            }
        })
        // let payload = {
        //     "doctor_detail_id": 39,
        //     "effective_date": "2021-11-23",
        //     "schedule": [
        //         {
        //             "day_id": 1,
        //             "session": [
        //                 {
        //                     "service_type": 3,
        //                     "time_type": 3,
        //                     "time": 0,
        //                     "quota": "20",
        //                     "quota_bpjs": null,
        //                     "time_start": "09:00",
        //                     "time_end": "18:00",
        //                     "room_id": 68,
        //                     "remarks": "",
        //                     "internal_notes": ""
        //                 }
        //             ]
        //         },
        //     ]
        // }
    }

    const columns = [
        {
            name: "Tombol Select",
            options: {
                filter: false,
                display: false,
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[19] === 1 ?
                                <button
                                    onClick={() => null}
                                    style={{
                                        backgroundColor: "transparent",
                                        fontSize: 20,
                                        outline: 'none',
                                        borderColor: 'transparent'
                                    }}>
                                    <img src={editIcon} style={{ width: 30, height: 30 }} />
                                </button>
                                :
                                ""}
                        </div>
                    )
                }
            }
        },
        {
            name: "Tombol Edit",
            options: {
                filter: false,
                display: false,
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[19] === 1 ?
                                <div style={{ display: 'flex' }}>
                                    <LightTooltip title={"Edit"} arrow>
                                        <button
                                            onClick={() => handleEdit(tableMeta)}
                                            style={{
                                                backgroundColor: "transparent",
                                                fontSize: 20,
                                                outline: 'none',
                                                borderColor: 'transparent'
                                            }}>
                                            <img src={editIcon} style={{ width: 30, height: 30 }} />
                                        </button>
                                    </LightTooltip>
                                    {tableMeta.rowData[20] === 1 &&
                                        <LightTooltip title={"Cancel Edit"} arrow>
                                            <button
                                                onClick={() => handleCancel(tableMeta)}
                                                style={{
                                                    backgroundColor: "transparent",
                                                    fontSize: 20,
                                                    outline: 'none',
                                                    borderColor: 'transparent'
                                                }}>
                                                <img src={editIcon} style={{ width: 30, height: 30 }} />
                                            </button>
                                        </LightTooltip>
                                    }
                                </div>
                                :
                                ""}
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            options: {
                filter: false,
                display: false,
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[19] === 1 ?
                                tableMeta.rowData[20] === 1 ?
                                    <div
                                        onClick={() => {
                                            dataTable.splice(tableMeta.rowIndex + 1, 0,
                                                [
                                                    tableMeta.rowData[0],
                                                    tableMeta.rowData[1],
                                                    tableMeta.rowData[2],
                                                    tableMeta.rowData[3],
                                                    tableMeta.rowData[4],
                                                    tableMeta.rowData[5],
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    0,
                                                    0,
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    "",
                                                    "",
                                                    "",
                                                    0,
                                                    1,
                                                    1
                                                ])
                                            forceUpdate()
                                        }}
                                        style={{ cursor: 'pointer' }}>
                                        Add
                                    </div>
                                    : "" : ""
                            }
                        </div >
                    )
                }
            }
        },
        {
            name: "Nama Klinik",
            options: {
                sort: true,
                // filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[19] === 1 ? val : ""}
                        </div>
                    )
                }
            }
        }, {
            name: "Nama Dokter",
            options: {
                sort: true,
                // filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[19] === 1 ? val : ""}
                        </div>
                    )
                }
            }
        }, {
            name: "Effective Date",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[19] === 1 ?
                                tableMeta.rowData[20] === 1 ?
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            format="yyyy-MM-dd"
                                            style={{ width: 200 }}
                                            clearLabel
                                            minDate={new Date()}
                                            value={new Date(val)}
                                            onChange={(date) => {
                                                dataTable[tableMeta.rowIndex][tableMeta.columnIndex] = date
                                                console.log(date);
                                                forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change time',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                    : format(new Date(val), 'yyyy-MM-dd') : null}
                        </div>
                    )
                }
            }
        }, {
            name: "Hari",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[20] === 1 ?
                                <Autocomplete
                                    style={{ width: 100 }}
                                    options={listHari}
                                    getOptionLabel={(option) => option}
                                    value={val}
                                    onChange={(event, newInputValue) => {
                                        dataTable[tableMeta.rowIndex][tableMeta.columnIndex] = newInputValue
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085' } }}
                                        />
                                    }
                                />
                                : val}
                        </div>
                    )
                }
            }
        }, {
            name: "Jam Mulai",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    let time = isNaN(new Date(val).getTime()) ? new Date(`2014-08-18T${val}`) : val
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[20] === 1 ?
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        style={{ width: 100 }}
                                        clearLabel
                                        ampm={false}
                                        value={time}
                                        onChange={(date) => {
                                            dataTable[tableMeta.rowIndex][tableMeta.columnIndex] = date
                                            forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change time',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                                : format(new Date(time), 'HH:mm')}
                        </div>
                    )
                }
            }
        }, {
            name: "Jam Selesai",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    let time = isNaN(new Date(val).getTime()) ? new Date(`2014-08-18T${val}`) : val
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[20] === 1 ?
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        style={{ width: 100 }}
                                        clearLabel
                                        ampm={false}
                                        value={time}
                                        onChange={(date) => {
                                            dataTable[tableMeta.rowIndex][tableMeta.columnIndex] = date
                                            forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change time',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                                : format(new Date(time), 'HH:mm')}
                        </div>
                    )
                }
            }
        }, {
            name: "Tipe Antrian",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[20] === 1 ?
                                <Autocomplete
                                    style={{ width: 150 }}
                                    options={listAntrian}
                                    getOptionLabel={(option) => option}
                                    value={val}
                                    onChange={(event, newInputValue) => {
                                        dataTable[tableMeta.rowIndex][tableMeta.columnIndex] = newInputValue
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085' } }}
                                        />
                                    }
                                />
                                : val}
                        </div>
                    )
                }
            }
        }, {
            name: "Slot Waktu",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[20] === 1 ?
                                <TextField
                                    style={{ width: 80 }}
                                    value={val}
                                    onBlur={(e) => {
                                        dataTable[tableMeta.rowIndex][tableMeta.columnIndex] = e.target.value
                                        forceUpdate()
                                    }}
                                />
                                : val}
                        </div>
                    )
                }
            }
        }, {
            name: "Kuota Pasien",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[20] === 1 ?
                                <TextField
                                    style={{ width: 80 }}
                                    value={val}
                                    onBlur={(e) => {
                                        dataTable[tableMeta.rowIndex][tableMeta.columnIndex] = e.target.value
                                        forceUpdate()
                                    }}
                                />
                                : val}
                        </div>
                    )
                }
            }
        }, {
            name: "Opsi Pembayaran",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[20] === 1 ?
                                <Autocomplete
                                    style={{ width: 120 }}
                                    options={listPembayaran}
                                    getOptionLabel={(option) => option}
                                    value={val}
                                    onChange={(event, newInputValue) => {
                                        dataTable[tableMeta.rowIndex][tableMeta.columnIndex] = newInputValue
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085' } }}
                                        />
                                    }
                                />
                                : val}
                        </div>
                    )
                }
            }
        }, {
            name: "Kuota BPJS",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                //     <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[20] === 1 ?
                                <TextField
                                    style={{ width: 80 }}
                                    value={val}
                                    onBlur={(e) => {
                                        dataTable[tableMeta.rowIndex][tableMeta.columnIndex] = e.target.value
                                        forceUpdate()
                                    }}
                                />
                                : val}
                        </div>
                    )
                }
            }
        }, {
            name: "Lokasi Praktek",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[20] === 1 ?
                                <Autocomplete
                                    style={{ width: 80 }}
                                    options={listRoom}
                                    getOptionLabel={(option) => option}
                                    value={val}
                                    onChange={(event, newInputValue) => {
                                        dataTable[tableMeta.rowIndex][tableMeta.columnIndex] = newInputValue
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085' } }}
                                        />
                                    }
                                />
                                : val}
                        </div>
                    )
                }
            }
        }, {
            name: "Catatan Publik",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[20] === 1 ?
                                <TextField
                                    style={{ width: 80 }}
                                    value={val}
                                    onBlur={(e) => {
                                        dataTable[tableMeta.rowIndex][tableMeta.columnIndex] = e.target.value
                                        forceUpdate()
                                    }}
                                />
                                : val}
                        </div>
                    )
                }
            }
        }, {
            name: "",
            options: {
                filter: false,
                display: false,
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {tableMeta.rowData[20] === 1 ?
                                <div style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        if (tableMeta.rowData[19] === 1) {
                                            dataTable.splice(tableMeta.rowIndex, 1)
                                            dataTable[tableMeta.rowIndex][19] = 1
                                            forceUpdate()
                                        } else {
                                            dataTable.splice(tableMeta.rowIndex, 1)
                                            forceUpdate()
                                        }
                                    }}>
                                    delete
                                </div> : ""
                            }
                        </div>
                    )
                }
            }
        }, {
            name: "Last Update Date",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Last Update By",
            options: {
                sort: true,
                filter: false,
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "",
            options: {
                display: false,
                filter: false
            }
        }, {
            name: "",
            options: {
                display: false,
                filter: false
            }
        }, {
            name: "",
            options: {
                display: false,
                filter: false
            }
        }];

        const options = {
            filterType: 'multiselect',
            fixedHeader: true,
            filter: false,
            search: false,
            sort: true,
            print: false,
            download: false,
            selectableRows: false,
            viewColumns: false,
            rowsPerPage: limit,
            count: dataCount,
            pagination: false,
            responsive: 'scrollMaxHeight',
            serverSide: true,
            onFilterChange: (columnChanged) => {
                // console.log(columnChanged, filterList, c, d, e, f, g);
                // props.setDataReservasi(e === undefined ? [] : e)
                // if (columnChanged === null) {
                //     setDataTable(null)
                //     setValidFrom(null)
                //     setValidTo(null)
                //     getData(page, limit, dokter, poliklinik, tglMulai, tglSelesai, namaPasien, opsiPembayaran, idReservasi, noAntri, status, reservasiVia, reason)
                // }
            },
            onTableChange: (action, tableState) => {
                // console.log(action, tableState);
                switch (action) {
                    case 'changePage':
                        setPage(tableState.page + 1)
                        setLimit(tableState.rowsPerPage)
                        getData(tableState.page + 1, tableState.rowsPerPage)
                        break;
                    case 'changeRowsPerPage':
                        setPage(tableState.page + 1)
                        setLimit(tableState.rowsPerPage)
                        getData(tableState.page + 1, tableState.rowsPerPage)
                        break;
                    case 'sort':
                        // setLoading(true)
                        sorting(tableState)
                        break;
                    default:
                        break;
                }
            }
        };
    
        const sorting = (tableState) => {
            let arr = dataTable
            console.log(dataTable);
            arr.sort(function (a, b) {
                if (String(tableState.announceText).includes('descending')) {
                    return String(a[tableState.activeColumn]).localeCompare(String(b[tableState.activeColumn])) ;
                } else {
                    return String(b[tableState.activeColumn]).localeCompare(String(a[tableState.activeColumn])) ;
                }
            });
            setDataTable(arr)
            // setLoading(false)
            forceUpdate()
        };

    return (
        <div style={{ height: '92vh' }}>
            <div style={{ width: '100%', margin: '.5vh', display: 'flex', justifyContent: 'space-between', padding: '.4vh .2vw 0' }}>
                <button style={{ padding: '2px 20px', backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                    onClick={() => setVisibleFilter(true)}
                >
                    <div style={{ display: 'flex' }}>
                        <Typography style={{ fontSize: 13, margin: 'auto', color: 'white' }}>Filter Data</Typography>
                    </div>
                </button>
                <button style={{ padding: '2px 20px', backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                    onClick={() => {
                        history.push({
                            pathname: '/schedule/draft-master-jadwal',
                            state: {
                                create,
                                update,
                                read,
                                deleted
                            }
                        })
                    }}
                >
                    <div style={{ display: 'flex' }}>
                        {/* <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" /> */}
                        {/* <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" /> */}
                        <Typography style={{ fontSize: 13, margin: 'auto', color: 'white' }}>Draft Jadwal</Typography>
                    </div>
                </button>
            </div>
            <div >
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={dataTable}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            </div>
            <div className={classes.root} style={{ justifyContent: 'center', display: 'flex', marginTop: '2vh' }}>
                <Pagination
                    count={dataCount}
                    onChange={(e, page) => {
                        console.log(e, page);
                        getData(page, limit)
                    }}
                    shape="rounded" />
            </div>
            {visibleFilter && (
                <div className="App app-popup-show">
                    <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18, }}>Filter Data</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisibleFilter(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div className="" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                            <Autocomplete
                                options={listDokter}
                                getOptionLabel={(option) => option.name}
                                style={{ width: '100%' }}
                                multiple
                                value={pickDokter}
                                onChange={(event, newInputValue) => {
                                    setPickDokter(newInputValue)
                                    forceUpdate()
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                        label="Nama Dokter"
                                    />
                                }
                            />
                            {/* <div className="column-2">
                                <TextField
                                    label={"Nama Klinik"}
                                    style={{ width: '90%' }}
                                    // onChange={(e) => {
                                    //     setItem(e.target.value)
                                    // }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                            fontFamily: 'Poppins',
                                        }
                                    }}
                                />
                            </div> */}
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => {
                                        setPickDokter([])
                                        setTimeout(() => {
                                            setVisibleFilter(false)
                                            getData(0, 10, 'reset')
                                        }, 200);
                                    }}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Reset</Typography>
                                </div>
                                <div onClick={(e) => {
                                    handleFilter()
                                    setVisibleFilter(false)
                                }} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Filter</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }
        </div >
    )
}
